/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * Bar.tsx - A bar for a bar model
*/

import { StyleSheet, Text, View } from 'react-native';
import { RFPercentage } from 'react-native-responsive-fontsize';

interface BarProps {
  isTop: boolean,
  number: number | string
}

const Bar = ({ isTop, number }: BarProps): JSX.Element => {

  if (isTop) {
    return (
      <View style={[styles.bar, styles.topBar]}>
        <View>
          <Text style={styles.barModelNumber}>{number}</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.bar, styles.bottomBar, ]}>
      <View>
        <Text style={styles.barModelNumber}>{number}</Text>
      </View>
    </View>
  );

};

export default Bar;

const styles = StyleSheet.create({

  bar: {
    borderWidth: 2,
    borderColor: '#20232a',
    color: '#20232a',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    height: '30%',
    padding: 5,
    margin: 0,
    flex: 1
  },

  topBar: {
    backgroundColor: '#ef816e',
  },

  bottomBar: {
    backgroundColor: '#bdd874',
  },

  barModelNumber: {
    fontSize: RFPercentage(3),
    fontFamily: 'WhiteRoseMathsFont',
    textAlign: 'center',
    alignContent: 'center',
    alignSelf: 'center'
  }

});
